export type GroupItemMode = 'compact' | 'normal' | 'normal-small';

export const DEFAULT_GROUP_ITEM_MODE = 'normal';
